import React, {useEffect, useState} from 'react'
import {Link, useNavigate} from "react-router-dom";
import KeyboardBackspaceTwoToneIcon from '@mui/icons-material/KeyboardBackspaceTwoTone';
import CarCrashTwoToneIcon from '@mui/icons-material/CarCrashTwoTone';
import {Button} from "@mui/material";
import './index.css';

//**********************************************************

function Header({pageTitle = "", showBtnBack = true, showBtnLastStatus = false, ...props})
{
    const navigate = useNavigate();
    const [isOffline, setIsOffline] = useState(false);

    //
    useEffect
    (
        () =>
        {
            setIsOffline(sessionStorage.getItem(String(process.env.REACT_APP_Offline)) === "1");
        },
        []
    );

    //
    const handleBack = () =>
    {
        navigate(-1);
    }

    const handleLogout = () =>
    {

    }

    //--------------------
    return (
        <header>
            <div>
                {showBtnLastStatus ? <Button type="button" className="btn-menu" disabled={isOffline} to="/last-status" component={Link}><CarCrashTwoToneIcon /></Button> : null}

                <span className="header-title">{pageTitle}</span>
            </div>

            {showBtnBack ? <Button type="button" className="btn-back" onClick={handleBack}><KeyboardBackspaceTwoToneIcon /></Button> : null}
        </header>
    );
}

export default Header;
